<msc-common-aside #aside [title]="'subscription.refuse.title' | translate" (saveEvent)="save()">
    <ng-template #asideTemplate>
        <msc-textarea [label]="'subscription.refuse.description' | translate" id="message" rows="5" cols="33" [(ngModel)]="message" [placeholder]="'placeholder.message' | translate"></msc-textarea>
    </ng-template>
</msc-common-aside>